"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nonEmptySku = exports.validateResponseHasContent = void 0;
const isEmpty_1 = __importDefault(require("ramda/src/isEmpty"));
const developmentThrow_1 = require("../utils/developmentThrow");
const validateResponseHasContent = (type) => (response) => response.toEither(Error(`${type} response did not return any values`));
exports.validateResponseHasContent = validateResponseHasContent;
const nonEmptySku = (sku) => {
    (0, isEmpty_1.default)(sku) && (0, developmentThrow_1.developmentThrow)('sku cannot be empty!');
    return sku;
};
exports.nonEmptySku = nonEmptySku;
//# sourceMappingURL=utils.js.map